import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { metricsQueryKeys } from "./metricsQueryKeys";

interface Params {
  name: string;
  orgId?: string;
}

export function useDeleteMetricDefinition() {
  const { metricsService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation<void, Error, Params>({
    mutationFn: ({ name, orgId }) =>
      metricsService.deleteMetricDefinition(name, { orgId }),
    onSuccess: (_, { name, orgId }) => {
      void queryClient.invalidateQueries({
        queryKey: metricsQueryKeys.definitions(),
      });
      // The single-definition cache is keyed by org, so a removal is only
      // meaningful with an org to scope it; without one there is nothing it
      // could match. The list invalidation above already refreshes the table.
      if (orgId !== undefined) {
        queryClient.removeQueries({
          queryKey: metricsQueryKeys.definition(name, orgId),
        });
      }
    },
  });
}
